// extracted by mini-css-extract-plugin
export default {"characterGrid":"CharacterGrid_characterGrid__Zls9Y"};